module.exports = __webpack_public_path__ + "img/bg.accf8710.png";